module.exports = __webpack_public_path__ + "img/logo.9d8816f4.svg";